import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { WallboardsApiModel } from '../../wallboards/wallboards.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root'
})
export class CxoneWallboardsService {
    public popoverObj: NgbPopover;

    constructor(
        private cvApiService: CVApiService
    ) {
    }

    public async loadWallboards(): Promise<WallboardsApiModel> {
        try {
            let response = await this.cvApiService.get<WallboardsApiModel>(`/api/v1/wallboards`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to load wallboards.`);
        }
    }

    
}
